import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import { AppComponent } from './app.component';
import { GeneralModule } from './modules/general/general.module';
import { LoginModule } from './modules/login/login.module';
import { PartnerModule } from './modules/partner/partner.module';
import { GiftcardModule } from './modules/giftcard/giftcard.module';
import { OrderModule } from './modules/order/order.module';
import { PaymentModule } from './modules/payment/payment.module';
import { BookingModule } from './modules/booking/booking.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { PageMainComponent } from './pages/page-main/page-main.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
import { LoggerService } from './services/logger/logger.service';
import { ConsoleLoggerService } from './services/logger/console-logger.service';
import { AppTitleService } from './services/app-title/app-title.service';
import { AppStateService } from './services/app-state.service';
import { AppTitleComponent } from './components/app-title/app-title.component';
import { environment } from '../environments/environment';
import { ConnectionService } from './services/connection/connection.service';
import { ConnectionOdooService } from './services/connection/connection-odoo.service';
import { SimulatorModule } from './modules/simulator/simulator.module';
import { LoadingSpinnerService } from './services/loading-spinner.service';
import { ContactModule } from './modules/contact/contact.module';
import { LocalizationService } from './services/localization.service';
import { CompanyWorkingHoursComponent } from './modules/contact/components/company-working-hours/company-working-hours.component';
import { CompanyInfoStateService } from './modules/contact/services/company-info-state.service';
import { PageFaqComponent } from './pages/page-faq/page-faq.component';
import { PagePrivacyComponent } from './pages/page-privacy/page-privacy.component';
import { PageAgbComponent } from './pages/page-agb/page-agb.component';
import { PageImpressumComponent } from './pages/page-impressum/page-impressum.component';
import { PageRegistrationComponent } from './pages/page-registration/page-registration.component';
import { PageThankYouComponent } from './pages/page-thank-you/page-thank-you.component';
import { AppCookieMessageComponent } from './components/app-cookie-message/app-cookie-message.component';
import { CookieModule } from 'ngx-cookie';
import { MailModule } from './modules/mail/mail.module';
import { InactiveTimerService } from './services/inactive-timer.service';
import { InactiveTimerComponent } from './components/inactive-timer/inactive-timer.component';
import { SessionTimerEndWarningDialogComponent } from './components/session-timer-end-warning-dialog/session-timer-end-warning-dialog.component';
// import { Angulartics2Module } from 'angulartics2';
// import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
// import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { BootstrapService } from './services/bootstrap.service';
import { PageImpressumDeComponent } from './components/app-impressum/app-impressum.component';
import { AppAgbComponent } from './components/app-agb/app-agb.component';
import { PageMaintenanceComponent } from './pages/page-maintenance/page-maintenance.component';
import { PageMaintenanceGuard } from './guards/page-maintenance.guard';
import { VUModule } from './modules/vu/vu.module';
import { TranslationsModule } from './modules/translations/translation.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppLogoComponent } from './components/app-logo/app-logo.component';
import { PageAgbPopupComponent } from './components/page-agb-popup/page-agb-popup.component';
import { ScheduleModule } from './modules/schedule/schedule.module';
// import { Angulartics2UirouterModule } from 'angulartics2/uiroutermodule';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import { LanguageSelectionPopUpComponent } from './components/languages/language-selection-popup/language-selection-popup.component';
import { lang } from 'moment';
import { PartnerCodeModule } from './modules/partner-code/partner-code.module';
import { PageRegistrationGuard } from './guards/page-registration.guard';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RefoundCardModule } from './modules/refund-card/refund-card.module';
import { AppPrivacyPolicyComponent } from './components/app-privacy-policy/app-privacy-policy.component';
import { PagePrivacyPolicyPopupComponent } from './components/page-privacy-policy-popup/page-privacy-policy-popup.component';
import { KioskModule } from './modules/kiosk/kiosk.module';
import { CameraModule } from './modules/camera/camera.module';
import { BasketButtonComponent } from './components/basket-button/basket-button.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { PinPopupComponent } from './components/pin-popup/pin-popup.component';
import { PinPadComponent } from './components/pin-pad/pin-pad.component';
// import { APP_BASE_HREF, PlatformLocation } from '@angular/common';


const routes: Routes = [
  {
    path: '',
    component: PageMainComponent,
    pathMatch: 'full',
    data:
    {
      title: ['READY', 'FOR TAKE OFF?!']
    }
  },
  {
    path: 'registration',
    canActivate: [PageRegistrationGuard],
    component: PageRegistrationComponent,
  },
  {
    path: 'thank_you',
    component: PageThankYouComponent,
  },
  {
    path: 'faq',
    component: PageFaqComponent,
  },
  {
    path: 'privacy',
    component: PagePrivacyComponent,
  },
  {
    path: 'agb',
    component: PageAgbComponent,
  },
  {
    path: 'aszf',
    component: PageAgbComponent,
  },
  {
    path: 'impressum',
    component: PageImpressumComponent,
  },
  {
    path: 'maintenance',
    canActivate: [PageMaintenanceGuard],
    component: PageMaintenanceComponent,
  },
  {
    path: '**',
    // TODO: 404 page not found!
    redirectTo: '/',
    pathMatch: 'full',
  },
];

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function init(bootstrapService: BootstrapService) {
  return () => bootstrapService.initialize();
}

// export function getBaseHref(platformLocation: PlatformLocation): string {
// return platformLocation.getBaseHrefFromDOM();
// }

const connectionServiceClass = environment.production ? ConnectionOdooService : ConnectionService;

@NgModule({
  declarations: [
    AppComponent,
    PageMainComponent,
    PageHeaderComponent,
    PageFooterComponent,
    AppTitleComponent,
    AppLogoComponent,
    InactiveTimerComponent,
    SessionTimerEndWarningDialogComponent,
    CompanyWorkingHoursComponent,
    PageFaqComponent,
    PagePrivacyComponent,
    PageAgbComponent,
    AppAgbComponent,
    AppPrivacyPolicyComponent,
    PageImpressumComponent,
    PageImpressumDeComponent,
    PageRegistrationComponent,
    PageThankYouComponent,
    AppCookieMessageComponent,
    PageMaintenanceComponent,
    PageAgbPopupComponent,
    PagePrivacyPolicyPopupComponent,
    LanguageSelectionPopUpComponent,
    BasketButtonComponent,
    PinPadComponent,
    PinPopupComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    RouterModule.forRoot(routes),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxSpinnerModule,
    GeneralModule.forRoot(),
    BookingModule,
    GiftcardModule,
    LoginModule,
    OrderModule,
    PartnerModule,
    PartnerCodeModule,
    RefoundCardModule,
    PaymentModule,
    SimulatorModule,
    ContactModule,
    CookieModule.forRoot(),
    MailModule,
    // Angulartics2Module.forRoot([Angulartics2GoogleAnalytics]),
    // Angulartics2Module.forRoot([Angulartics2GoogleTagManager]),
    // Angulartics2UirouterModule.forRoot([Angulartics2GoogleTagManager]),
    VUModule,
    TranslationsModule,
    FontAwesomeModule,
    ScheduleModule,
    NoopAnimationsModule,
    KioskModule,
    CameraModule,
    InlineSVGModule.forRoot(),
  ],
  exports: [
    RouterModule,
    PageHeaderComponent,
    PageFooterComponent,
    AppTitleComponent,
    InactiveTimerComponent,
    SessionTimerEndWarningDialogComponent,
    CompanyWorkingHoursComponent,
    AppCookieMessageComponent,
  ],
  providers: [
    AppTitleService,
    AppStateService,
    LoadingSpinnerService,
    [{ provide: LoggerService, useClass: ConsoleLoggerService }],
    [{ provide: ConnectionService, useClass: connectionServiceClass }],
    CompanyInfoStateService,
    LocalizationService,
    {
      provide: APP_INITIALIZER,
      useFactory: init,
      deps: [BootstrapService],
      multi: true
    },
//    {
//      provide: APP_BASE_HREF,
//      useFactory: getBaseHref,
//      deps: [PlatformLocation]
//    },
    InactiveTimerService,
    PageMaintenanceGuard,
    PageRegistrationGuard,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    SessionTimerEndWarningDialogComponent,
    PageAgbPopupComponent,
    PagePrivacyPolicyPopupComponent,
    LanguageSelectionPopUpComponent,
    PinPopupComponent,
  ]
})
export class AppModule {
  constructor(
    translate: TranslateService,
    localizationService: LocalizationService,
    logger: LoggerService
  ) {
    translate.setDefaultLang('en-US');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    const availableLangs = localizationService.availableLangs;
    if (availableLangs.length > 0) {
      translate.use(availableLangs[0]);
    } else {
      translate.use('de-DE');
    }
    localizationService.initialize();
  }
}
